import { configureStore } from '@reduxjs/toolkit';
import authReducer from './store/slices/authSlice';
import exchangeOfficeReducer from './store/slices/exchangeOfficeSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    exchangeOffice: exchangeOfficeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;